module.exports = __webpack_public_path__ + "img/color_jp.74d933a.jpg";